const sharedKeysByAppEnv = {
    stage: 'WZiyIX4nfCZ7G0b0ZEO7boMPnZZFzjWw',
    test: 'q5csJBEG77tF1PrfG2ilc0CqNwPsEWJE',
    prod: 'BGnTdxPHAw7r7tNB03yaxqgAs6xYlNtD',
    'pen-test': 'iMD8wG3YzDfIAEGgCS0Eyl68SQXmoqPY',
};
/**
 * Get segment key for new shared source for all applications
 * @param env - Side environment
 * @returns Segment key
 */
export function getSharedSegmentKey(env) {
    return sharedKeysByAppEnv[env];
}
